import React from "react";
import {
  Breadcrumb,
  BreadcrumbGroup,
  HeaderPage,
  TemplateFullGutter
} from "@common/DynamicUikit";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { CombinedReducersType } from "@redux/reducer";
import { StylingType } from "@type/index";
import { NotFound } from "../../common";

type IProps = {
  type: StylingType;
};

const NotFoundPage = (props: IProps) => {
  const { type } = props;
  const { t } = useTranslation();
  const config = useSelector((store: CombinedReducersType) => store.config);

  const navigationPath = (
    <BreadcrumbGroup className="fr-ec-mb-spacing-05">
      <Breadcrumb element="a" href={config.basePath}>
        {t("text_breadcrumbs_top")}
      </Breadcrumb>
      <Breadcrumb element="a" href="">
        {type === StylingType.official
          ? `${t("text_styling_book_header_title").toUpperCase()} ${t(
              "text_styling_book_official_styling"
            )}`
          : `${t("text_styling_book_header_title").toUpperCase()} ${t(
              "text_styling_book_stylehint"
            )}`}
      </Breadcrumb>
    </BreadcrumbGroup>
  );

  const mainContent = (
    <>
      <HeaderPage
        title={t("text_styling_book_header_title").toUpperCase()}
        className="fr-ec-mb-spacing-05"
      />
      <NotFound
        text={
          type === StylingType.official
            ? t("text_official_styling_top_page_link")
            : t("text_stylehint_top_page_link")
        }
        type={
          type === StylingType.official
            ? StylingType.official
            : StylingType.stylehint
        }
      />
    </>
  );

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{t("text_404")}</title>
        <meta name="description" content={t("text_404")} />
      </Helmet>
      <TemplateFullGutter
        mainContent={mainContent}
        navigationPath={navigationPath}
      />
    </>
  );
};
export default NotFoundPage;
